export default __webpack_public_path__ + "static/media/Food Reel 2019.69b260fb.mp4";